import AppConfig from "config";
import axios from "axios";

const TranscriptController = {
  async listTranscripts(jwtToken, page) {
    try {
      const response = await axios.get(AppConfig.BACKEND_URL+`/transcripts`, {
        headers: {
          Authorization: `Bearer ${jwtToken}`,
        },
        params: {
          page: page
        }
      });
      return response.data;
    } catch (error) {
      console.error("Error fetching transcripts:", error);
      throw error;
    }
  },

  async getTranscriptsByAudit(jwtToken, auditId) {
    try {
      const response = await axios.get(AppConfig.BACKEND_URL_REFATORADO+`transcripts_page/transcripts/by_audit/${auditId}`, {
        headers: {
          Authorization: `Bearer ${jwtToken}`,
        }
      });
      return response.data.result;
    } catch (error) {
      console.error("Error fetching transcripts by audit:", error);
      throw error;
    }
  },
  async AddToRetranscript(jwtToken, idtranscripts, vad_filter, repenalty) {
    try {
      const response = await axios.post(AppConfig.BACKEND_URL_REFATORADO + `publisher_rabbitmq/publisher`, {
        queue: 'files_to_retranscript',
        body: 'inserting on the queue',
        idtranscripts: idtranscripts,
        vad_filter: vad_filter,
        repenalty: repenalty
      }, {
        headers: {
          Authorization: `Bearer ${jwtToken}`,
        },
      });
      return response.data;
    } catch (error) {
      console.error("Error creating user:", error);
      throw error;
    }
  },
};

export default TranscriptController;